import Model from '@/models/Model.js';

export default class TimePeriodEnrollment extends Model {
    static entity = 'time_period_enrollment';

    static modelName = 'TimePeriodEnrollment';

    static primaryKey = ['time_period_id', 'user_id'];

    static fields() {
        return {
            time_period_id: this.attr(null),
            user_id: this.attr(null),
            course_enrollment_id: this.attr(null),
            role_id: this.attr(null),
            pivot: this.attr(null),

            ...super.fields(),

            time_period: this.belongsTo('time_periods', 'time_period_id'),
            user: this.belongsTo('users', 'user_id'),
            course_enrollment: this.belongsTo('course_enrollments', 'course_enrollment_id'),
            role: this.belongsTo('roles', 'role_id'),
        };
    }
}
